import { createSelector } from "reselect";
import { get } from "lodash";

import { RESOURCE_URI_CHUNKS } from "../../../constants/entity.js";
import { MARKING_STATES } from "../../../utils/marking.js";

import selectorUtils from "../selectorUtils.js";
import operationSelector from "../operations/operationSelector.js";

// -- QUERIES -- //

const userIdQuery = state => get(state, "account.data.@id", null);
const inviteDataQuery = state => get(state, "invites.dataMap", null);

const inviteIndexQuery = (state, props, id) => {
  const inviteId = id
    ? id
    : selectorUtils.getAtIdFromMatchProps(props, RESOURCE_URI_CHUNKS.INVITES);
  const inviteIndex = get(state, `invites.dataIndex`, null);

  // if we have an invite id reorder the result so that this is presented first
  if (inviteIndex && inviteId && inviteIndex.indexOf(inviteId) > -1) {
    const result = inviteIndex.filter(item => item !== inviteId);
    result.unshift(inviteId);
    return result;
  }

  return inviteIndex;
};

// there is currently no error at this level if the indviteId doesn't exist
const selectInvites = inviteId => {
  return createSelector(
    [inviteIndexQuery, inviteDataQuery, operationSelector.permissionsQuery],
    (inviteIndex, inviteData, permissions) => {
      // bail early if we don't have an invite
      if (!inviteIndex || !inviteData) return null;

      const result = inviteIndex.map(item => {
        return inviteData[item];
      });

      return operationSelector.stampOperationPermissions(result, permissions);
    }
  );
};

const selectPendingInvites = limit => {
  return createSelector(
    [
      inviteIndexQuery,
      inviteDataQuery,
      userIdQuery,
      operationSelector.permissionsQuery
    ],
    (inviteIndex, inviteData, userId, permissions) => {
      // bail early if we don't have an invite
      if (!inviteIndex || !inviteData) return null;

      let result = inviteIndex.filter(item => {
        const invite = inviteData[item];
        return (
          invite.marking === MARKING_STATES.PENDING ||
          invite.marking === MARKING_STATES.PENDING_OBJECT ||
          invite.marking === MARKING_STATES.PENDING_SUBJECT
        );
      });

      result = result.slice(0, limit).map(item => {
        const invite = inviteData[item];
        return {
          ...invite,
          isUser: userId === get(invite, "createdBy.@id", null)
        };
      });

      return operationSelector.stampOperationPermissions(result, permissions);
    }
  );
};

// using the following export pattern so we can mock more easily using jest

const inviteSelector = {
  inviteDataQuery,
  inviteIndexQuery,
  selectInvites,
  selectPendingInvites
};

export default inviteSelector;
